import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import useBoundingClientRect from '../../customHooks/useBoundingClientRect';
import { CollapseBodyWrapper, CollapseContainer } from './subcomponents';
export const collapseDuration = 0.6;
const Collapse = ({ id, className, children, duration = collapseDuration, expand = false }) => {
    const ref = useRef();
    const { height } = useBoundingClientRect(ref);
    const timeOutDuration = duration * 1000;
    const [transitionHasEnded, setTransitionHasEnded] = useState(false);
    const onTransitionHasEnded = useCallback(() => {
        return setTimeout(() => {
            setTransitionHasEnded(expand);
        }, timeOutDuration);
    }, [expand, timeOutDuration]);
    useEffect(() => {
        const transitionId = onTransitionHasEnded();
        return () => {
            clearTimeout(transitionId);
        };
    }, [expand, onTransitionHasEnded]);
    return (_jsx(CollapseBodyWrapper, Object.assign({ id: id, "aria-hidden": !expand, className: className, "$isExpanded": expand, "$duration": duration, "$transitionHasEnded": transitionHasEnded, "$height": height }, { children: _jsx(CollapseContainer, Object.assign({ "$isExpanded": expand, "$duration": duration, ref: ref }, { children: children })) })));
};
export default Collapse;
//# sourceMappingURL=Collapse.js.map